export const copyText = (text: string) => {
  if (!navigator.clipboard) {
    return new Promise<void>((resolve, reject) => {
      const input = document.createElement('input');

      document.body.appendChild(input);

      input.value = text;
      input.style.position = 'fixed';
      input.style.zIndex = '-100';
      input.select();
      input.setSelectionRange(0, text.length);
      if (document.execCommand('copy')) {
        document.body.removeChild(input);
        resolve();
        return;
      }
      reject();
    });
  }
  return navigator.clipboard.writeText(text);
};

export const copy = (source: string | HTMLCanvasElement) => {
  if (typeof source === 'string') {
    return copyText(source);
  }
  source.toBlob((blob) => {
    if (blob) {
      const data = new ClipboardItem({ [blob.type]: blob });
      navigator.clipboard.write([data]);
    }
  });
};
